import { Injectable } from '@angular/core';
import { JsonHttpService } from 'src/app/shared/http/json-http.service';

@Injectable({
    providedIn: 'root'
})
export class SystemLinksService {

    constructor(private httpService: JsonHttpService) {
    }

    getHelpUrl(): Promise<string> {
        return this.httpService.get('/api/systemlinks/get_help_url').toPromise();
    }

    getDocumentationUrl(): Promise<string> {
        return this.httpService.get('/api/systemlinks/get_documentation_url').toPromise();
    }
}
